"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var replace_1 = __importDefault(require("lodash/replace"));
var AperzaDataUtil = /** @class */ (function () {
    function AperzaDataUtil() {
    }
    /**
     * 企業名を取得
     * @param companyName
     */
    AperzaDataUtil.formatCompanyName = function (companyName, langCode, tradeName, tradeNamePositionCode) {
        var name = companyName;
        if (tradeName) {
            if (langCode === 'ja') {
                //ラベル表示する場合「その他」を含む商号は表示しない
                //When displaying labels, trade names including "Other" are not displayed.
                var _tradeName = replace_1.default(tradeName, /.*その他.*/, '');
                if (parseInt(tradeNamePositionCode) === 1) {
                    name = "" + _tradeName + companyName;
                }
                else if (parseInt(tradeNamePositionCode) === 2) {
                    name = "" + companyName + _tradeName;
                }
            }
        }
        return name;
    };
    AperzaDataUtil.convertCluezCompanyIdToCompanyContractDisplayId = function (cluezCompanyId) {
        var cluezCompanyIdString = '' + cluezCompanyId;
        if (cluezCompanyIdString.length != 8 && !isNaN(parseInt(cluezCompanyId))) {
            return '1' + cluezCompanyIdString.padStart(7, '0');
        }
        return cluezCompanyId;
    };
    return AperzaDataUtil;
}());
exports.default = AperzaDataUtil;
//# sourceMappingURL=AperzaDataUtil.js.map